import React from "react";
import { SUBTYPES } from "../constants";
import { REQUEST_TYPES, ROLES } from "shared/config";
import { useRequestPersistedStore, useRequestStore } from "entities/Request";

/**
 * Custom hook to generate cost type options for card and expense request types.
 *
 * @param {Object} params - Parameters for the hook.
 * @param {Array} params.costTypes - Array of available cost types.
 * @param {Object} params.costLineData - Data for the specific cost line.
 * @param {boolean} params.isJobRelated - Flag indicating if the request is job-related.
 * @returns {Array} An array of cost type options formatted for a dropdown or select input.
 */
export function useCostTypeOptions({ costTypes, costLineData, isJobRelated }) {
  const userRole = useRequestPersistedStore(
    (state) => state.viewRequestAs.role
  );
  const request = useRequestStore((state) => state.request);

  const currentSubType = costLineData?.cost_type?.data?.subtype;
  return React.useMemo(() => {
    if (!costTypes) return [];
    return costTypes
      .filter((costType) => {
        if (isJobRelated) return costType?.subtype === SUBTYPES.JOB_RELATED;
        else return costType?.subtype !== SUBTYPES.JOB_RELATED;
      })
      .filter((costType) => {
        if (
          (request?.type === REQUEST_TYPES.AMEX_BTA ||
            request?.type === REQUEST_TYPES.CREDIT_CARD) &&
          (costLineData?.is_splitted || costLineData?.splitted_cost_id !== null)
        ) {
          // TODO remove hardcode by label
          return costType.label === "To be billed back";
        }
        if (userRole === ROLES.ACCOUNTS_PAYABLE) {
          if (currentSubType === SUBTYPES.MILEAGE) {
            return costType?.subtype === SUBTYPES.MILEAGE;
          }
          return costType?.subtype !== SUBTYPES.MILEAGE;
        }
        return true;
      })
      .map((costType) => ({
        value: { id: costType.id, subtype: costType.subtype },
        vatCodes: costType.available_vat_codes?.data,
        label: costType.name,
      }));
  }, [costTypes, currentSubType, userRole, isJobRelated, costLineData]);
}
